
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Dasselbe wie Müks. MOH ist die englische Abkürzung für «`}<b>{`m`}</b>{`edication`}</p>
    <b>o</b>veruse
    <b>h</b>eadache».
Auf
Deutsch:
    <b>M</b>edikamenten-
    <b>Ü</b>bergebrauch-
    <b>K</b>opf
    <b>s</b>chmerz,
also
Müks.
Das
bedeutet,
dass
die
Schmerzmittel
die
Kopfschmerzen
verursachen.
MOH
oder
Müks
sind
aber
nicht
zu
verwechseln
mit
einer
Nebenwirkung.
Zum
Beispiel
verursachen
Medikamente
wie
Viagra
für
die
Potenz,
Östrogene
in
der
Anti-Baby-Pille
oder
Nifedipin
gegen
Angina
pectoris
oft
Kopfweh
als
Begleiterscheinung.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;